import { useContext } from "react";
import { AppContext } from "../providers/AppContext";
import { useMediaQuery } from "react-responsive";
import { PiButterflyFill } from "react-icons/pi";

export default function Controls() {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { setCameraState } = useContext(AppContext);

  return (
    <div
      className={`fixed bottom-6 z-40 flex gap-4 transform ${
        isMobile
          ? "right-6 flex-col"
          : "left-1/2 -translate-x-1/2 flex-row"
      }`}
    >
      <button
        onClick={() => setCameraState((prev) => (prev === 5 ? 0 : 5))}
        aria-label="Butterfly control"
        className="size-12 md:size-16 rounded-full bg-[#316897] border-3 md:border-4 border-[#abf630] flex items-center justify-center shadow-lg 
                  cursor-pointer transition hover:scale-110 
                  outline-none focus:outline-none focus:ring-0 select-none active:outline-none"
        style={{
          WebkitTapHighlightColor: "transparent",
        }}
      >
        <PiButterflyFill className="text-[#abf630] size-6 md:size-8" />
      </button>
      
      <button
        onClick={() => {
          setCameraState((prev) => (prev >= 4 ? 0 : prev + 1));
        }}
        aria-label="Primary control"
        className="size-12 md:size-16 rounded-full bg-[#316897] border-3 md:border-4 border-[#abf630] flex items-center justify-center shadow-lg 
                  cursor-pointer transition hover:scale-110 
                  outline-none focus:outline-none focus:ring-0 select-none active:outline-none"
        style={{
          WebkitTapHighlightColor: "transparent",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="size-12 md:size-16 text-[#abf630]"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
}
